var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottom2GradientTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 574,
    viewBox: "0 0 283 574",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1025_13442)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.5,
    cy: 287,
    rx: 103.5,
    ry: 104,
    fill: "#7D97F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1025_13442",
    x: 0,
    y: 0,
    width: 573,
    height: 574,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 91.5,
    result: "effect1_foregroundBlur_1025_13442"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom2GradientTablet);
export default __webpack_public_path__ + "static/media/bottom2_gradient_tablet.4f0da4b6cb7f0d3a9109fd1f14618961.svg";
export { ForwardRef as ReactComponent };